import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CheckBox, DBCheckBox, DBTextArea } from '_components';
import styles from './Common.module.css';
import { fixCommas, getDateMDYYYY } from '_helpers';

class PatientCareCenterNoteAssessmentPN extends React.Component {

    getAssessmentSentence() {
        let flagLimitations = Object.keys(this.props.selectedFlagLimitations).map(key => this.props.selectedFlagLimitations[key].AFFLAGTEXT).join(', ');
        if (this.props.ass.ASLIMITATIONSTXT) {
            this.props.selectedFlagLimitations.length > 0 ? flagLimitations += ', ' + this.props.ass.ASLIMITATIONSTXT : flagLimitations += this.props.ass.ASLIMITATIONSTXT;
        }
        flagLimitations = fixCommas(flagLimitations);

        let flagImproves = Object.keys(this.props.selectedFlagImproves).map(key => this.props.selectedFlagImproves[key].AFFLAGTEXT).join(', ');
        if (this.props.ass.ASIMPROVETXT) {
            this.props.selectedFlagImproves.length > 0 ? flagImproves += ', ' + this.props.ass.ASIMPROVETXT : flagImproves += this.props.ass.ASIMPROVETXT;
        }
        flagImproves = fixCommas(flagImproves);

        let goalDifficulties = Object.keys(this.props.selectedGoalDifficulties).map(key => this.props.selectedGoalDifficulties[key].label).join(', ');
        if (this.props.ass.ASDIFFICULTYTXT) {
            this.props.selectedGoalDifficulties.length > 0 ? goalDifficulties += ', ' + this.props.ass.ASDIFFICULTYTXT : goalDifficulties += this.props.ass.ASDIFFICULTYTXT;
        }
        goalDifficulties = fixCommas(goalDifficulties);

        let goalImproves = Object.keys(this.props.selectedGoalImproves).map(key => this.props.selectedGoalImproves[key].label).join(', ');
        if (this.props.ass.ASABILITYTO) {
            this.props.selectedGoalImproves.length > 0 ? goalImproves += ', ' + this.props.ass.ASABILITYTO : goalImproves += this.props.ass.ASABILITYTO;
        }
        goalImproves = fixCommas(goalImproves);

        let sentence = "";
        sentence += 'Since the last assessment, the patient has made improvements in ';
        sentence += flagImproves ? flagImproves : '[improvement(s)]';
        sentence += '.  Now the patient has improved ability to perform ';
        sentence += goalImproves ? goalImproves : '[goal(s)]';
        sentence += ' as a result of ';
        sentence += this.props.ass.ASRESULTOFSKILLS ? this.props.ass.ASRESULTOFSKILLS : '[skillset]';
        sentence += '.  The patient continues to demonstrate limitations in ';
        sentence += flagLimitations ? flagLimitations : '[limitation(s)]';
        sentence += ' which is contributing to difficulty with ';
        sentence += goalDifficulties ? goalDifficulties : '[goal(s)]';
        sentence += '.  Therefore the skills of a therapist are warranted in order to ';
        sentence += this.props.ass.ASSKILLS ? this.props.ass.ASSKILLS : '[skillset]';
        sentence += '.';
        sentence = sentence.endsWith('.') ? sentence : sentence += '.';
        return sentence;
    }

    selectAllImproveClicked(val) {
        this.props.updateAllAssessmentFlags(this.props.noteId, this.props.ass.ASNO, val, 'improve');
    }

    selectAllLimitsClicked(val) {
        this.props.updateAllAssessmentFlags(this.props.noteId, this.props.ass.ASNO, val, 'limit');
    }

    selectAllGoalImproveClicked(val) {
        this.props.updateAllGoalFlags(this.props.noteId, this.props.ass.ASNO, val, 'improve');
    }

    selectAllGoalDifficultClicked(val) {
        this.props.updateAllGoalFlags(this.props.noteId, this.props.ass.ASNO, val, 'limit');
    }
    render() {
        return (
            <div className={styles.body_wrapper}>
                <span className={styles.row}>
                    <div className={styles.assessment_sentence}>
                        {this.getAssessmentSentence()}
                    </div>
                </span>
                <span className={styles.row}>
                    <label className={styles.required}>Since the last assessment, the patient has made improvements in:</label>
                </span>
                {this.props.flags.length > 0 &&
                    <span className={styles.row}>
                        <CheckBox
                            checked={this.props.flags.length === this.props.selectedFlagImproves.length}
                            className={styles.checkbox_all}
                            onClick={(val) => this.selectAllImproveClicked(val)}
                            label='All'
                        />
                    </span>
                }
                {Object.keys(this.props.flags)
                    .map(key => {
                        const result = this.props.flags[key];
                        return (
                            <span key={result.AFNO} className={styles.row}>
                                <DBCheckBox
                                    noteId={this.props.noteId}
                                    entity='PTASSESSMENTFLAGS'
                                    entityKeyColumn='AFNO'
                                    entityKeyValue={result.AFNO}
                                    field='AFIMPROVEMENT'
                                    className={styles.checkbox}
                                    label={result.AFFLAGTEXT}
                                />
                            </span>
                        )
                    })
                }
                <DBTextArea
                    noteId={this.props.noteId}
                    entity='PTASSESSMENT'
                    entityKeyColumn='ASNO'
                    entityKeyValue={this.props.ass.ASNO}
                    field='ASIMPROVETXT'
                    placeholder='Please list improvements separated by commas.  For example: test a, test b, test c'
                    className={styles.textarea}
                />


                <span className={styles.row}>
                    <label className={styles.required}>Now the patient has improved ability to perform:</label>
                </span>
                {this.props.goals.length > 0 &&
                    <span className={styles.row}>
                        <CheckBox
                            checked={this.props.goals.length === this.props.selectedGoalImproves.length}
                            className={styles.checkbox_all}
                            onClick={(val) => this.selectAllGoalImproveClicked(val)}
                            label='All'
                        />
                    </span>
                }

                {Object.keys(this.props.goals)
                    .map(key => {
                        const result = this.props.goals[key];
                        return (
                            <span key={result.GONO} className={styles.row}>
                                <DBCheckBox
                                    noteId={this.props.noteId}
                                    entity='PTGOALS'
                                    entityKeyColumn='GONO'
                                    entityKeyValue={result.GONO}
                                    field='GOIMPROVE'
                                    className={styles.checkbox}
                                    label={result.label}
                                />
                            </span>
                        )
                    })
                }
                <DBTextArea
                    noteId={this.props.noteId}
                    entity='PTASSESSMENT'
                    entityKeyColumn='ASNO'
                    entityKeyValue={this.props.ass.ASNO}
                    field='ASABILITYTO'
                    placeholder='Please list functional activities separated by commas.  For example: activity a, activity b, activity c'
                    className={styles.textarea}
                />

                <span className={styles.row}>
                    <label className={styles.required}>As a result of:</label>
                </span>
                <DBTextArea
                    noteId={this.props.noteId}
                    entity='PTASSESSMENT'
                    entityKeyColumn='ASNO'
                    entityKeyValue={this.props.ass.ASNO}
                    field='ASRESULTOFSKILLS'
                    placeholder='Please list specific skills delivered by the therapist that have resulted in gains since the last assessment.'
                    className={styles.textarea}
                />
                <span className={styles.row}>
                    <label className={styles.required}>The patient continues to demonstrate limitations in:</label>
                </span>
                {this.props.flags.length > 0 &&
                    <span className={styles.row}>
                        <CheckBox
                            checked={this.props.flags.length === this.props.selectedFlagLimitations.length}
                            className={styles.checkbox_all}
                            onClick={(val) => this.selectAllLimitsClicked(val)}
                            label='All'
                        />
                    </span>
                }
                {Object.keys(this.props.flags)
                    .map(key => {
                        const result = this.props.flags[key];
                        return (
                            <span key={result.AFNO} className={styles.row}>
                                <DBCheckBox
                                    noteId={this.props.noteId}
                                    entity='PTASSESSMENTFLAGS'
                                    entityKeyColumn='AFNO'
                                    entityKeyValue={result.AFNO}
                                    field='AFLIMITATION'
                                    className={styles.checkbox}
                                    label={result.AFFLAGTEXT}
                                />
                            </span>
                        )
                    })
                }
                <DBTextArea
                    noteId={this.props.noteId}
                    entity='PTASSESSMENT'
                    entityKeyColumn='ASNO'
                    entityKeyValue={this.props.ass.ASNO}
                    field='ASLIMITATIONSTXT'
                    placeholder='Please list limitations separated by commas.  For example: test a, test b, test c'
                    className={styles.textarea}
                />


                <span className={styles.row}>
                    <label className={styles.required}>This is contributing to difficulty with:</label>
                </span>
                {this.props.goals.length > 0 &&
                    <span className={styles.row}>
                        <CheckBox
                            checked={this.props.goals.length === this.props.selectedGoalDifficulties.length}
                            className={styles.checkbox_all}
                            onClick={(val) => this.selectAllGoalDifficultClicked(val)}
                            label='All'
                        />
                    </span>
                }

                {Object.keys(this.props.goals)
                    .map(key => {
                        const result = this.props.goals[key];
                        return (
                            <span key={result.GONO} className={styles.row}>
                                <DBCheckBox
                                    noteId={this.props.noteId}
                                    entity='PTGOALS'
                                    entityKeyColumn='GONO'
                                    entityKeyValue={result.GONO}
                                    field='GODIFFICULT'
                                    className={styles.checkbox}
                                    label={result.label}
                                />
                            </span>
                        )
                    })
                }
                <DBTextArea
                    noteId={this.props.noteId}
                    entity='PTASSESSMENT'
                    entityKeyColumn='ASNO'
                    entityKeyValue={this.props.ass.ASNO}
                    field='ASDIFFICULTYTXT'
                    placeholder='Please list functional activities separated by commas.  For example: activity a, activity b, activity c'
                    className={styles.textarea}
                />

                <span className={styles.row}>
                    <label className={styles.required}>Therefore the skills of a therapist are warranted in order to:</label>
                </span>
                <DBTextArea
                    noteId={this.props.noteId}
                    entity='PTASSESSMENT'
                    entityKeyColumn='ASNO'
                    entityKeyValue={this.props.ass.ASNO}
                    field='ASSKILLS'
                    placeholder='Please list the impact on ADLs separated by commas.  For example: return to job function, navigate the home, care for children.'
                    className={styles.textarea}
                />

                <span className={styles.row}>
                    <label>Other Comments:</label>
                </span>
                <DBTextArea
                    noteId={this.props.noteId}
                    entity='PTASSESSMENT'
                    entityKeyColumn='ASNO'
                    entityKeyValue={this.props.ass.ASNO}
                    field='ASCOMMENTS'
                    className={styles.textarea}
                />

                {this.props.isBMITIFEnabled &&
                    <span className={styles.row}>
                         <DBCheckBox
                                    noteId={this.props.noteId}
                                    entity='PTASSESSMENT'
                                    entityKeyColumn='ASNO'
                                    entityKeyValue={this.props.asno}
                                    field='ASNUTCOUNSEL'
                                    className={styles.checkbox}
                                    label="Patient was referred to nutrition counseling for abnormal BMI when appropriate"
                                />
                                <span className={styles.row}>
                                </span>
                                <DBCheckBox
                                    noteId={this.props.noteId}
                                    entity='PTASSESSMENT'
                                    entityKeyColumn='ASNO'
                                    entityKeyValue={this.props.asno}
                                    field='ASTOBFREEFL' 
                                    className={styles.checkbox}
                                    label="Patient was referred to Tobacco Free Florida for cessation of tobacco products when appropriate"
                                />
                    </span>
                }

                {this.props.prevAss && Date.parse(this.props.prevAss.DOS) > Date.parse('01/01/1970') &&
                    <div className={styles.row}>
                        <label className={styles.prev_ass_label}>{getDateMDYYYY(this.props.prevAss.DOS) + ' Assessment'}</label>
                        <label className={styles.prev_ass}>{this.props.prevAss.ASSESSMENT}</label>
                    </div>
                }



            </div >
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        updateAllAssessmentFlags: bindActionCreators(noteActions.updateAllAssessmentFlags, dispatch),
        updateAllGoalFlags: bindActionCreators(noteActions.updateAllGoalFlags, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isBMITIFEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['BMI_TFF_ENABLED'].PRVALUE === 'true' : false;
    let isPeds = state.entities.admissions[epno].isPeds && isPedsEnabled;
    let asno = parseInt(Object.keys(state.entities.notes.PTASSESSMENT)
        .find(key => (state.entities.notes.PTASSESSMENT[key].ASEVNO === pk && noteType === 1)
            || (state.entities.notes.PTASSESSMENT[key].ASNTNO === pk && noteType !== 1)));
    let ass = state.entities.notes.PTASSESSMENT[asno];
    let diagVal = state.entities.notes.PTASSESSMENT[asno].ASAWAREDIAG !== null ? state.entities.notes.PTASSESSMENT[asno].ASAWAREDIAG === true ? '1' : '2' : undefined;
    let flags = Object.keys(state.entities.notes.PTASSESSMENTFLAGS)
        .filter(key => {
            return state.entities.notes.PTASSESSMENTFLAGS[key].AFASNO === asno;
        })
        .sort((a, b) => { return state.entities.notes.PTASSESSMENTFLAGS[a].AFNO - state.entities.notes.PTASSESSMENTFLAGS[b].AFNO; })
        .map(key => state.entities.notes.PTASSESSMENTFLAGS[key]);

    let selectedFlagLimitations = Object.keys(state.entities.notes.PTASSESSMENTFLAGS)
        .filter(key => {
            return state.entities.notes.PTASSESSMENTFLAGS[key].AFASNO === asno && state.entities.notes.PTASSESSMENTFLAGS[key].AFLIMITATION === true;
        })
        .sort((a, b) => { return state.entities.notes.PTASSESSMENTFLAGS[a].AFNO - state.entities.notes.PTASSESSMENTFLAGS[b].AFNO; })
        .map(key => state.entities.notes.PTASSESSMENTFLAGS[key]);

    let selectedFlagImproves = Object.keys(state.entities.notes.PTASSESSMENTFLAGS)
        .filter(key => {
            return state.entities.notes.PTASSESSMENTFLAGS[key].AFASNO === asno && state.entities.notes.PTASSESSMENTFLAGS[key].AFIMPROVEMENT === true;
        })
        .sort((a, b) => { return state.entities.notes.PTASSESSMENTFLAGS[a].AFNO - state.entities.notes.PTASSESSMENTFLAGS[b].AFNO; })
        .map(key => state.entities.notes.PTASSESSMENTFLAGS[key]);

    let goals = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => state.entities.notes.PTGOALS[key].GONTNO === pk
            && (state.entities.notes.PTGOALS[key].GOMGNO || state.entities.notes.PTGOALS[key].GOCUSTOM)
            && state.entities.notes.PTGOALS[key].GODELETED !== true
        )
        .sort((a, b) => { return state.entities.notes.PTGOALS[a].GONO - state.entities.notes.PTGOALS[b].GONO; })
        .map(key => {
            let label = '';
            if (state.entities.notes.PTGOALS[key].GOCUSTOM) {
                label = state.entities.notes.PTGOALS[key].GOCUSTOM;
            } else {
                label = state.entities.masterData.PTMASTERGOALS[
                    Object.keys(state.entities.masterData.PTMASTERGOALS)
                        .find(key2 => (state.entities.masterData.PTMASTERGOALS[key2].MGNO === state.entities.notes.PTGOALS[key].GOMGNO))].MGASSESSMENT;
                if (label === 'performing essential job demand' && state.entities.notes.PTGOALS[key].GOWORKTASK) {
                    label += ' (' + state.entities.notes.PTGOALS[key].GOWORKTASK + ')';
                }
            }
            return {
                GONO: state.entities.notes.PTGOALS[key].GONO,
                GODIFFICULT: state.entities.notes.PTGOALS[key].GODIFFICULT,
                GOIMPROVE: state.entities.notes.PTGOALS[key].GOIMPROVE,
                label: label
            };
        });

    let selectedGoalImproves = Object.keys(goals)
        .filter(key => {
            return (goals[key].GOIMPROVE === true);
        })
        .map(key => goals[key]);

    let selectedGoalDifficulties = Object.keys(goals)
        .filter(key => {
            return (goals[key].GODIFFICULT === true);
        })
        .map(key => goals[key]);

    let prevAssKey = Object.keys(state.entities.notes.PTASSESSMENTPREV)
        .find(key => {
            return (state.entities.notes.PTASSESSMENTPREV[key].NoteId === noteId);
        });
    let prevAss = prevAssKey ? state.entities.notes.PTASSESSMENTPREV[prevAssKey] : undefined;


    return {
        noteId,
        noteType,
        ass,
        isPeds,
        diagVal,
        flags,
        selectedFlagLimitations,
        selectedFlagImproves,
        goals,
        selectedGoalImproves,
        selectedGoalDifficulties,
        prevAss,
        isBMITIFEnabled,
        asno
    };
}

const connectedPatientCareCenterNoteAssessmentPN = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteAssessmentPN);
export { connectedPatientCareCenterNoteAssessmentPN as PatientCareCenterNoteAssessmentPN };

